import {Checkbox, FormControlLabel} from "@mui/material";

export function ReassignInventoryForNewCodes(props: {
    value: boolean;
    onChange(tf: boolean): void;
}) {
    return (
        <FormControlLabel
            control={
                <Checkbox
                    size="small"
                    checked={props.value}
                    onChange={(e) => props.onChange(e.target.checked)}
                />
            }
            label="Reassign existing inventory to new codes based on dimension"
            componentsProps={{typography: {variant: "body2"}}}
        />
    );
}
